import { render, staticRenderFns } from "./ChatBar.vue?vue&type=template&id=6228b6d3&scoped=true"
import script from "./ChatBar.vue?vue&type=script&lang=js"
export * from "./ChatBar.vue?vue&type=script&lang=js"
import style0 from "./ChatBar.vue?vue&type=style&index=0&id=6228b6d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228b6d3",
  null
  
)

export default component.exports